import React from "react";
import { siteContent } from "../content";
import Disclaimer from "./Disclaimer.component";
import FormFields from "./form/FormFields";
const intro = siteContent.intro;
const bySubscribing = siteContent.bySubscribing;

const Hero = () => {
  return (
    <div className="container">
      <h3 className="mt-0 md:mt-0 mb-4 text-lg text-slate-700">
        {intro.subscribeToOur} {intro.newsletter}
      </h3>
      <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 leading-snug ">
        {intro.whatWillYouFind_Part1}{" "}
        <span className="text-greenish capitalize">
          {intro.whatWillYouFind_Part2}
        </span>
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-12">
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-5 text-lg text-center">
            {bySubscribing.content.map((item, k) => (
              <div
                key={k}
                className="bg-white px-5 py-5 pb-10 shadow-lg shadow-greenish/10 rounded-lg"
              >
                <div className="w-full">
                  <div className="w-28 h-28 block mx-auto rounded-full m-4 p-8 border-2 border-muted/50">
                    <img src={item.img} alt={item.title} />
                  </div>
                </div>
                <p className="text-slate-700">{item.title}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="border border-primary/20 shadow-lg shadow-greenish/10 rounded-lg p-5">
          <FormFields />
          <Disclaimer />
        </div>
      </div>
    </div>
  );
};

export default Hero;
